module.exports = __webpack_public_path__ + "static/img/it1_en.61358ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/data/it1_en.png
// module id = +aIM
// module chunks = 0